import type { Point2d, Rectangle2d } from ".."

export const boxToMatrix = (
  rectangle: Rectangle2d,
  spacing: Point2d,
  quadrant: 1 | 2 | 3 | 4 = 1,
  inset: Point2d = { x: 0, y: 0 },
): Point2d[] => {
  const pointsHorizontal = Math.floor((rectangle.w - inset.x) / spacing.x)
  const pointsHorizontalRemainder = rectangle.w % spacing.x
  const horizontalOffset = [2, 3].includes(quadrant)
    ? pointsHorizontalRemainder
    : 0
  const pointsVertical = Math.floor((rectangle.h - inset.y) / spacing.y)
  const pointsVerticalRemainder = rectangle.h % spacing.y
  const verticalOffset = [3, 4].includes(quadrant) ? pointsVerticalRemainder : 0
  const points: Point2d[] = []
  for (let i = 0; i < pointsHorizontal; i++) {
    for (let j = 0; j < pointsVertical; j++) {
      const x = rectangle.x + i * spacing.x + horizontalOffset + inset.x
      const y = rectangle.y + j * spacing.y + verticalOffset + inset.y
      points.push({ x, y })
    }
  }

  return points
}
